export default "__VITE_ASSET__BCZc3jjS__"